import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAppEmailVerificationRestricted } from './EmailVerificationRestrictionContext';
import { isAllowedPathWhileEmailUnverified } from './appEmailVerificationRestriction';

const EmailVerificationOverviewGuard = ({ children }) => {
  const location = useLocation();
  const navigationLocked = useAppEmailVerificationRestricted();

  if (navigationLocked && !isAllowedPathWhileEmailUnverified(location.pathname)) {
    return <Navigate to="/app/overview" replace />;
  }

  return children;
};

export default EmailVerificationOverviewGuard;
